import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'locationName',
    header: 'Location Name',
    type: 'text',
  },
  {
    key: 'locationType',
    header: 'Type',
    type: 'text',
  },
  {
    key: 'locationAddress',
    header: 'Address',
    type: 'text',
    width: 60,
    placeholder: 'Not Provided',
  },
  {
    key: 'rebuildTime',
    header: 'Rebuild Time (Months)',
    type: 'number',
  },
];
